import React from 'react'
import Grid from '@mui/material/Grid'
import { Box, Button, IconButton, InputAdornment } from '@mui/material'

import { useNavigate } from 'react-router-dom'

import { StudentLoginFormFields } from './StudentLoginFormFields'
import { useStudentLogin } from '../../../hooks/useStudentLogin'
import { Visibility, VisibilityOff } from '@mui/icons-material';
import TextField from '@mui/material/TextField';

const StudentAuthForm = () => {  
  const{errors, handleSubmit, formData, onChange,showPassword, handleClickShowPassword, isLoading}= useStudentLogin()  
  const navigate = useNavigate()
  const navigateReginsterPage = () => {
    navigate('/students-registration')
  }
  const navigateForgotPassPage = () => {
    navigate('/forgot-password')
  }
  const submitForm =(e)=>{
  e.preventDefault()
  // console.log("Form is submiting");
  handleSubmit()

  
}

  return (
    <>
             <form onSubmit={submitForm} style={{width:"100%"}}>
      <Box sx={{ width: '100%' }}>
        <div className="title_container mb-20">
          <h1>NICE TO SEE YOU</h1> 
        </div>
        <Box className="stepper_wrapper" sx={{ p: 4 }}>
          <div className="title_container mb-20">
            <h2>Welcome to Success Tutorial! Student Login</h2>
          </div>

      <Grid item xs={12} md={12} sx={{ marginBottom: '20px' }}>
        <TextField
          fullWidth
          value={formData?.emailOrMobile || ''}
          placeholder="Mobile Number or Email"
          error={!!errors?.emailOrMobile}
          helperText={errors?.emailOrMobile}
          onChange={(e) => onChange('emailOrMobile', e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <box-icon type="solid" name="user-rectangle"></box-icon>
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <TextField
          fullWidth
          type={showPassword ? 'text' : 'password'}
          placeholder="Password"
          value={formData?.password || ''}
          error={!!errors.password}
          helperText={errors.password}
          onChange={(e) => onChange('password', e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{ marginLeft: '10px', marginRight: '10px' }}
              >
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sx={{ marginTop: '20px' }}>
        <Button
        type='submit'
          sx={{ borderRadius: '0' }}
          fullWidth
          // onClick={validateLogin}
          className="btn-default"
          // onClick={handleSubmit}
          disabled={isLoading}
          
        >
          {isLoading ? 'Loading...' : "Login"}
        </Button>
      </Grid>
          
                  <Box>
            <Grid item xs={12} md={12}>
              <div className="btnbg mt-20">
                <button onClick={navigateForgotPassPage} className="btn btn-lg">
                  <span>Forgot Password</span>
                </button>
                <button onClick={navigateReginsterPage} className="btn btn-lg">
                  <span>Register now</span>
                </button>
              </div>
            </Grid>
          </Box>
        </Box>
      </Box>
      </form>
    </>
  )
}

export { StudentAuthForm }